import script from "./cgw_zk.vue?vue&type=script&setup=true&lang=js"
export * from "./cgw_zk.vue?vue&type=script&setup=true&lang=js"

import "./cgw_zk.vue?vue&type=style&index=0&id=67bfb88b&lang=less"

const __exports__ = script;

export default __exports__